import { LocalDate, nativeJs } from "@js-joda/core";

//! @ngInject
export function caregiverPayRateResetModalCtrl(DatabaseApi, $rootScope, toaster, $scope, $uibModalInstance) {
    $scope.patientId = null;
    $scope.isSubmitting = false;

    $scope.handlePatientSelection = (patient) => {
        $scope.patientId = patient.id;
    };
    $scope.handlePatientDeselect = () => {
        $scope.patientId = null;
    };

    $scope.payrollCodes = DatabaseApi.payrollCodes()
        .filter(code =>
            !code.nonPayable
            && code.isActive
            && $scope.$resolve.certifications
            && $scope.$resolve.certifications.indexOf(code.certification) !== -1
        )
        .map(code => ({ id: code.id, label: code.displayId }));

    $scope.rate = { payCode: {} };

    $scope.endDatePickerOptions = {
        minDate: $scope.rate.startDate,
        startingDay: $rootScope.visitSettings.calendarStartDayOfTheWeek
    };

    $scope.payCodesMultiselectSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '250px',
        enableSearch: true,
        selectionLimit: 1,
        showUncheckAll: true,
        showCheckAll: false
    };

    $scope.cancelModal = function () {
        $uibModalInstance.dismiss('dismiss');
    };

    $scope.updateFromOptions = function () {
        $scope.endDatePickerOptions = { minDate: $scope.rate.startDate };
    };

    $scope.resetOverride = function () {
        $scope.isSubmitting = true;

        const body = {
            payCode: $scope.rate.payCode && $scope.rate.payCode.id ? $scope.rate.payCode.id : null,
            patientId: $scope.patientId || null,
            startDate: $scope.rate.startDate ? LocalDate.from(nativeJs($scope.rate.startDate)) : null,
            endDate: $scope.rate.endDate ? LocalDate.from(nativeJs($scope.rate.endDate)) : null
        };

        DatabaseApi.post(
            'agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId + '/caregivers/' + $scope.$resolve.caregiverId + '/pay_rates/reset',
            body
        ).then(function (res) {
            const count = res.data.resetCount;
            toaster.pop('success', "Pay rate overrides reset successfully", count + " override(s) reset to default");
            $uibModalInstance.close('success');
        }, function () {
            $scope.isSubmitting = false;
            toaster.pop('error', "Something went wrong", "Could not reset caregiver pay rate overrides");
        });
    };
}
